import styled from "@emotion/styled";
import { Box } from "Components";

const HEADER_BG = "#F3F3F3";

export const HeaderGrid = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr 2fr 2fr 2fr;
    align-items: flex-end;
    gap: 2px;
`;

export const HeaderCell = styled(Box)`
    background: ${HEADER_BG};
    text-align: center;
    padding: 12px;
    min-width: 110px;
`;

export const MentorHeaderCell = styled(HeaderCell)`
    text-align: left;
`;

export const SlotGrid = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px;
`;

export const SlotCell = styled(Box)`
    display: grid;
    gap: 15px;
    min-width: 110px;
`;
